import React from 'react'


export const Banner = ({ username, brokerName }) => {
  return (
    <div className="signupHeader">
      <h1>Your Owner&apos;s Edge account</h1>
      <h3>
        {username}
        {brokerName ? ' at ' : ''}
        {brokerName}
      </h3>
    </div>)
}
